import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import { Box, Button, PaletteColor, useTheme } from '@mui/material'
import React from 'react'
import { useUserSettings } from 'src/Hooks'
import { EonLogo } from '../../resources'
import { ExtensionCategoryNames, ExtensionDetailsProps, ExtensionTypes } from '../../types'
import { DetailsViewWrapper, HeaderContent } from '../general'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'

/**
 * Gives a detailed description of the E.ON extension.}
 */
const EonDetails: React.FC<ExtensionDetailsProps> = ({ onClose, place = 0 }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const description = isFlowTheme ? t('installation-extensions.eon.details.description.flow') : t('installation-extensions.eon.details.description')

  return (
    <DetailsViewWrapper
      extensionType={ExtensionTypes.Eon}
      descriptions={[description]}
      headerContent={<HeaderContent logo={<EonLogo />} />}
      footerContent={<FooterContent />}
      onClose={onClose}
      place={place}
      open={true}
      category={{ name: ExtensionCategoryNames.ElectricityTariffAddOn, paletteColor: theme.palette.blue as PaletteColor }}
    />
  )
}

const FooterContent: React.FC = () => {
  const { t } = useCustomTranslation()
  const { userSettings } = useUserSettings()
  const { pageActions } = useNewRelic()

  const onClick = (): void => {
    pageActions.componentClicked({
      componentName: 'EonDetailsDialog',
      userId: userSettings.userid?.toString(),
    })
    window.open('https://www.eon.de/de/pk/landingpage/hems/e3dc-eon-home-comfort.html', '_blank', 'noopener,noreferrer')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <Button variant="outlined" onClick={onClick}>
        {t('installation-extensions.eon.modal.button')}
      </Button>
    </Box>
  )
}

export default EonDetails
